import React from 'react';
import PropTypes from 'prop-types';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import Strings from '../../../Strings';

function HashtagsWindow(props) {
  const {hashtags, onTagChosen, onReplace, noBrackets } = props;
  const advancedMode = onReplace;
  return (
    <OverlayScrollbarsComponent
      defer
      className="scrollbar-right-margin-min"
      options={{ scrollbars: { autoHide: 'leave', autoHideDelay: '100' } }}
    >
      <div className="suggestion-flex">
        {hashtags &&
          hashtags.map(p => (
            <div
              key={`prefab-${p}`}
              className="message-textbox__suggestions__item"
              onClick={() => advancedMode ? undefined : onTagChosen(noBrackets ? p : `[${p}]`)}
            >
              <div className="tag-suggestion">
                <div 
                  data-tooltip-content={Strings.messageTagHelp?.[p]}
                  data-tooltip-id="tooltip"
                >
                  {p}
                </div>
                {advancedMode && (
                  <div className="tag-suggestion__buttons">

                    <button className="link-button" onClick={() => onReplace(p)}>
                      {Strings.replaceMessage}
                    </button>
                    <button className="link-button" onClick={() => onTagChosen(p)}>
                      {Strings.insertIntoMessage}
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </OverlayScrollbarsComponent>
  );
}

HashtagsWindow.propTypes = {
  hashtags: PropTypes.arrayOf(PropTypes.string),
  onTagChosen: PropTypes.func,
  onReplace: PropTypes.func,
  noBrackets: PropTypes.bool,
};

export default HashtagsWindow;
